import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import PersonIcon from "@mui/icons-material/Person";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Popper from "@mui/material/Popper";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import PeopleIcon from '@mui/icons-material/People';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CategoryIcon from '@mui/icons-material/Category';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import * as MuiIcons from '@mui/icons-material';
import config from "../config/config";

const drawerWidth = 240;
function Sidenav(props) {
  const token = localStorage.getItem("token");
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };
  useEffect(() => {
    // This code runs when the component mounts or updates.
    console.log("Functions on page load");
    fetchMenu();
    userDetails();
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.clear();
    navigate("/login");
  };
  const navigate = useNavigate();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const [menu, setMenu] = React.useState([]);
  const [submenus, setSubmenus] = useState({}); // Store submenus for each menu item
  const [openMenu, setOpenMenu] = useState(null); // Track which menu is open
  const fetchMenu = async () => {
    // Replace with actual token
    try {
      const response = await axios.get(`${config.baseUrl}/Menu?user_id=${encodeURIComponent(localStorage.getItem("user_id"))}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      console.log("menu:", response.data);
      if (response.status === 200) {
        setMenu(response.data);
        console.log("menu:", response.data);
      } else {
        console.error("Unexpected response:", response.status, response.data);
      }
    } catch (error) {
      console.error("Error fetching menu", {
        message: error.message,
        response: error.response?.data || null,
      });
    }
  };

  const handleMenuClick = async (id) => {
    console.log("Menu clicked:", id);

    // Toggle submenu visibility
    if (openMenu === id) {
      setOpenMenu(null); // Close the submenu if it's already open
      return;
    }

    try {
      const response = await axios.post(
        `${config.baseUrl}/Menu/submenu?user_id=${encodeURIComponent(localStorage.getItem("user_id"))}&menu_id=${encodeURIComponent(id)}`,
        null, // POST body is empty since params are in query string
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        console.log("Fetched submenus:", response.data);
        setSubmenus((prev) => ({ ...prev, [id]: response.data })); // Update submenus state
        setOpenMenu(id); // Open the clicked menu item
      } else {
        console.error("Unexpected response:", response.status, response.data);
      }
    } catch (error) {
      console.error("Error fetching submenu:", {
        message: error.message,
        response: error.response?.data || null,
      });
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      <List
        sx={{
          bgcolor: "#72BAA9",
          color: "#fff", // Set a uniform background color for the list
          //p: 1, 
          size: "small",
          p: 0,
          m: 0// Add padding around the list for better spacing
        }}
      >
        {menu.map((item) => (
          <React.Fragment key={item.id}>
            <ListItem
              disablePadding
              sx={{
                //bgcolor: "#EBEAFF", // List item background color
                // mb: 0.5,
                size: "small", // Reduced margin for compact spacing
                //borderRadius: 1, // Border radius for list items
              }}
            >
              <ListItemButton onClick={() => handleMenuClick(item.id)} >
                <ListItemText primary={item.menu} />
              </ListItemButton>
            </ListItem>
            {/* Render submenus if available and the menu item is open */}
            {openMenu === item.id && submenus[item.id] && (
              <List
                sx={{

                  // bgcolor: "#e0e0e0", // Submenu background color
                  //borderRadius: 1, // Border radius for submenus
                }}
              >
                {submenus[item.id].map((submenu) => (
                  <ListItem
                    key={submenu.submenu_id}
                    disablePadding
                    sx={{
                      size: "small",
                      //bgcolor: "#EBEAFF", // Submenu item background color
                      // mb: 0.5, // Reduced margin for compact spacing
                      borderRadius: 1, // Border radius for submenu items
                    }}
                  >
                    <ListItemButton href={submenu.url}>
                      <Stack direction="row" spacing={1}>
                        <i className={submenu.icon}></i>
                        <ListItemText primary={submenu.submenu} />
                      </Stack>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </React.Fragment>
        ))}
      </List>
    </div>
  );


  // Remove this const when copying and pasting into your project.
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  const [username, setUserName] = React.useState("");
  const [img, setImg] = React.useState("");
  const [role, setRole] = React.useState("");
  const [open1, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [conPass, setConPass] = React.useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const userDetails = async () => {
    // Replace with actual token
    try {
      const response = await axios.get(
        `${config.baseUrl}/Crud/usersById?id=${localStorage.getItem("user_id")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        console.log(response.data[0].name);
        console.log(response.data[0].img);
        setUserName(response.data[0].name);
        setImg(response.data[0].img);
        setRole(response.data[0].role);
      } else {
        console.error("Unexpected response:", response.status, response.data);
      }
    } catch (error) {
      console.error("Error fetching user count:", {
        message: error.message,
        response: error.response?.data || null,
      });
    }
  };

  const handlePasswordChange = async () => {
    try {
      const token = localStorage.getItem("token"); // Replace with your token logic
      const user_id = localStorage.getItem("user_id"); // Get user_id from localStorage

      if (password !== conPass) {
        handleClose();
        return Swal.fire("Error", "Password does not match", "error");
      } else {
        const url = `${config.baseUrl}/Crud/changePassword?user_id=${encodeURIComponent(
          user_id
        )}&pass=${encodeURIComponent(password)}`; // Append parameters to URL

        const response = await axios.post(
          url,
          null, // No request body since params are in the URL
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          console.log(response.data.executeMessage);
          handleClose();
          Swal.fire({
            title: "Success",
            text: response.data.executeMessage,
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              localStorage.clear();
              navigate("/login");
            }
          });
        } else {
          handleClose();
          console.error("Unexpected response:", response.status, response.data);
          Swal.fire("Error", response.data[0]?.executeMessage || "Unknown error", "error");
        }
      }
    } catch (error) {
      console.error("Error changing password:", {
        message: error.message,
        response: error.response?.data || null,
      });

      Swal.fire(
        "Error",
        "Failed to change password. Please try again.",
        "error"
      );
    }
  };



  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            justifyContent: "space-between",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            <a href="/" style={{ color: "inherit", textDecoration: "none" }}>Project Management</a>
          </Typography>

          <div>
            <IconButton
              aria-describedby={id}
              type="button"
              onClick={handleClick}
            >
              <AccountCircleIcon />
            </IconButton>
            <Popper
              id={id}
              open={open}
              anchorEl={anchorEl}
              modifiers={[
                {
                  name: "zIndex",
                  enabled: true,
                  options: {
                    zIndex: 1301, // Ensure it's above the drawer's z-index (default Drawer z-index is 1200)
                  },
                },
              ]}
            >
              <Box
                sx={{
                  p: 3,
                  bgcolor: "background.paper",
                  mt: 3,
                  mr: 2,
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Stack spacing={2} direction="row" mb={2}>
                  <img
                    src={img}
                    alt="Avatar"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <Typography variant="body1">
                    {username}
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {role}
                    </Typography>
                  </Typography>
                </Stack>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpen}
                  >
                    Change Password
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </Stack>
              </Box>
            </Popper>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>

        <Modal
          open={open1}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              textAlign={"center"}
            >
              Change Password
            </Typography>
            <hr />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  New Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="New Password"
                />
              </FormControl>

              <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Confirm Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={conPass}
                  onChange={(e) => setConPass(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm Password"
                />
              </FormControl>
              <Stack
                spacing={1}
                direction="row"
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePasswordChange}
                  disabled={password === "" || conPass === ""}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#D7D3BF", color: "#000" }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Stack>
            </Typography>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

Sidenav.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default Sidenav;
